<template>
  <div>
    <v-btn small color="primary" @click="dialog = true">Add Employee</v-btn>
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
        <v-card-title>Add Employee</v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              label="Employee ID"
              v-model="form.userid"
              :rules="rules"
            ></v-text-field>
            <v-text-field
              label="Employee Name"
              v-model="form.name"
              :rules="rules"
            ></v-text-field>
            <v-select
              label="Department"
              :items="departments"
              item-text="department_name"
              item-value="id"
              v-model="form.department_id"
              :rules="rules"
            ></v-select>
            <v-select
              label="Employment Status"
              :items="['Regular', 'Contract of Service', 'Job Order']"
              v-model="form.employment_status"
              :rules="rules"
            ></v-select>
            <v-select
              label="Device Name"
              :items="devices"
              item-text="device_name"
              item-value="id"
              v-model="form.device_id"
              :rules="rules"
            ></v-select>
            <v-select
              label="Work Schedule"
              :items="schedules || []"
              item-text="name"
              item-value="id"
              v-model="form.schedule_id"
              clearable
              hint="Leave empty to use the default schedule"
              persistent-hint
            ></v-select>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="add" color="primary">Add</v-btn>
          <v-btn @click="dialog = false" color="">Close</v-btn>
        </v-card-actions>
      </v-card></v-dialog
    >
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      dialog: false,
      valid: true,
      form: {},
      rules: [(v) => !!v || "Data is required"],
    };
  },
  methods: {
    add() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        let x = window.confirm("Are you sure you want to add this employee?");
        if (x) {
          this.add_employee(this.form);
        }
      }
      this.loading = false;
    },

    ...mapActions({
      get_departments: "department/get_departments",
      add_employee: "employee/add_employee",
      get_devices: "device/get_devices",
      get_schedules: "schedule/get_schedules",
    }),
  },
  created() {
    if (this.departments.length <= 0) this.get_departments();
    if (this.devices.length <= 0) this.get_devices();
    if (!this.schedules) this.get_schedules();
  },
  computed: {
    ...mapGetters({
      departments: "department/departments",
      devices: "device/devices",
      schedules: "schedule/schedules",
    }),
  },
};
</script>

<style></style>
